import React from "react";
import { toast } from "react-toastify";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useUserCustomers, useRemoveUserCustomer } from "../hooks";
import { useMe } from "../../users/hooks/useMe";
import { UserRole } from "../../../__generated__/globalTypes";

interface IProps {
  userId: number;
}

export const UserCustomersList: React.FC<IProps> = ({ userId }) => {
  const { data, loading, refetch } = useUserCustomers({ where: { userId } });
  const [removeUserCustomer] = useRemoveUserCustomer();
  const { data: meData } = useMe();
  const isAdmin = meData?.me?.role === UserRole.Admin;

  const handleRemove = async (id: number) => {
    if (!window.confirm("Retirer ce client rattaché ? Cette action est irréversible.")) return;
    try {
      const { data } = await removeUserCustomer({ variables: { id } });
      if (data?.removeUserCustomer?.ok) {
        toast.success("Le client a été retiré");
        refetch();
      } else {
        toast.error(data?.removeUserCustomer?.error ?? "Une erreur est survenue");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  if (loading) return <Loading />;

  if (!data?.userCustomers?.results?.length) {
    return <EmptyList text="Aucun client rattaché" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Client</TableCell>
          {isAdmin && (
            <TableCell header align="right">
              Actions
            </TableCell>
          )}
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.userCustomers?.results?.map((userCustomer) => (
          <TableRow key={`user-customer-${userCustomer.id}`} hover={false}>
            <TableCell>{userCustomer.customerId}</TableCell>
            {isAdmin && (
              <TableCell align="right">
                <span
                  className="text-red-500 cursor-pointer"
                  onClick={() => handleRemove(userCustomer.id)}
                >
                  Retirer
                </span>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
